import { makeStyles } from "@material-ui/core";
export const useStyles = makeStyles((theme) => ({
    wrapper: {
        maxWidth: "100%",
        gap: "32px",
        "&.MuiGrid-spacing-xs-2": {
            margin: "40px 0px",
        },
        "&.MuiGrid-spacing-xs-2 > .MuiGrid-item": {
            padding: "24px",
        },
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
        },
    },
    splitContent: {
        backgroundColor: theme.palette.background.paper,
        flex: "1 1 0",
        width: "100%",
        alignItems: "center",
        margin: 0,
    },
    textBlock: {
        "& h2, & h3, & h4": {
            marginTop: "40px",
            marginBottom: "40px",
        },
        "& img": {
            marginBottom: "0px",
            width: "100%",
            height: "auto",
            [theme.breakpoints.down("xs")]: {
                paddingTop: "24px",
            },
        },
        "& p": {
            padding: "0px 24px",
            marginTop: "24px",
            marginBottom: "24px",
            [theme.breakpoints.down("xs")]: {
                padding: "0px",
            },
            "&>a": {
                [theme.breakpoints.up("sm")]: {
                    marginRight: "12px",
                    marginLeft: "12px",
                    marginBottom: "12px",
                },
            },
        },
    },
    noImage: {
        display: "grid",
        alignItems: "center",
    },
    imageAfterContent: {
        "& img": {
            [theme.breakpoints.down("sm")]: {
                marginBottom: "24px",
                paddingTop: 0,
            },
        },
    },
    webshopEntryBlock: {
        "& form": {
            marginTop: 40,
        },
        "& p": {
            [theme.breakpoints.down("sm")]: {
                marginTop: 0,
            },
        },
    },
    columnBlock: {
        "& > .MuiContainer-root": {
            padding: 0,
            maxWidth: "100%",
        },
        "& > .MuiContainer-root .text-area": {
            [theme.breakpoints.up("sm")]: {
                padding: "0px",
            },
        },
    },
}));
